import recommendationsModule from "../recommendationsModule.js";

const recommendationsComponent = {
    templateUrl: "recommendations",
    bindings: {
        "recommendationTargetId": "<?",
        "recommendationType": "<",
        "recommendationSubtype": "<?",
        "pageName": "@",
        "showSeeAllButton": "<?"
    },
    controller: "recommendationsController"
};

recommendationsModule.component("recommendations", recommendationsComponent);
export default recommendationsComponent;